class ProductMain extends HTMLElement {
    constructor() {
      super();
  
      this._selectors = {
        addToCart: "[js-add-to-cart]",
        error: '[js-error-message]',
        form: "[js-product-form]",
        thumbnail: '[js-thumbnail]',
        loader: "loading-spinner",
        carousel: '[js-carousel]',
        carouselSlide: '[js-carousel-slide]',
        thumbsTrigger: '[js-thumbs-trigger]',
        thumbsContainer: '[js-thumbs-container]',
        productImagesModalCarousel: '[js-product-images-modal-carousel]',
        productImagesModal: '#ProductImagesModal',
        closeModalIcon: '[close-product-images-modal]',
        dropdownMenu: '[js-dropdown-menu-related-colors]'
      };
    }
  
    connectedCallback() {
      this.buttons = this.querySelectorAll(this._selectors.addToCart);
      this.addEventListener("variant:change", this._handleVariantChange);
      this._initProductForm();
      this._initColorSwatch();
      this._handlePageLoad();
    }  

    _handlePageLoad() {
      document.addEventListener('load', () => {
        this.classList.add('loaded');
      })
    }

    _initColorSwatch() {
      this.dropdownMenu = this.querySelector(this._selectors.dropdownMenu);
      this._getRelatedColorJSON();
    }

    _getRelatedColorJSON() {
      fetch('/products.json?limit=250&page=1').then(r => r.json()).then( p => {
        for (let i = 0; i < p.products.length; i++) {
          const productTitle = p.products[i].title.split("/")[0].trim();
          if (productTitle === this.dataset.relatedColorTitle.trim()) {
            this._buildDropdownOptions(p.products[i]);
          }
        }
      })
      fetch('/products.json?limit=250&page=2').then(r => r.json()).then( p => {
        for (let i = 0; i < p.products.length; i++) {
          const productTitle = p.products[i].title.split("/")[0].trim();
          if (productTitle === this.dataset.relatedColorTitle.trim()) {
            this._buildDropdownOptions(p.products[i]);
          }
        }
      })
      fetch('/products.json?limit=250&page=3').then(r => r.json()).then( p => {
        for (let i = 0; i < p.products.length; i++) {
          const productTitle = p.products[i].title.split("/")[0].trim();
          if (productTitle === this.dataset.relatedColorTitle.trim()) {
            this._buildDropdownOptions(p.products[i]);
          }
        }
      })

    }

    _buildDropdownOptions(option) {
      const optionDropdownLink = document.createElement('a');
      const image = document.createElement('img');
      const optionValue = option.title.split("/")[1];
      const optionTitle = document.createElement('div');
      optionTitle.innerHTML = optionValue
      image.src = `//www.johnelliott.com/cdn/shop/files/${optionValue.toLowerCase().trim().replace(/ /g, "-")}.png`;
      image.alt = optionValue;
      image.classList.add('pv-select__item-image');
      optionDropdownLink.href = `/products/${option.handle}`;
      optionDropdownLink.classList.add('product-option__dropdown-item-link');
      optionDropdownLink.appendChild(image);
      optionDropdownLink.appendChild(optionTitle);
      this.dropdownMenu.appendChild(optionDropdownLink);
    }

    _initProductForm() {
      this.form = this.querySelector(this._selectors.form);
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.cartDrawer = document.querySelector('#CartDrawer')
      this.thumbsTrigger = this.querySelector(this._selectors.thumbsTrigger);
      this.thumbsContainer = this.querySelector(this._selectors.thumbsContainer);
      this.productImagesModal = document.querySelector(this._selectors.productImagesModal);
      this.closeModalIcon = document.querySelector(this._selectors.closeModalIcon);

      this.querySelectorAll(this._selectors.thumbnail).forEach((button) => {
        button.addEventListener('click', this._slideTo);
      });

      this.querySelectorAll(this._selectors.carouselSlide).forEach((slide) => {
        slide.addEventListener('click', this._slideToModal.bind(this));
      });

      if (this.thumbsTrigger) {
        this.thumbsTrigger.addEventListener('click', this._handleThumbsClick.bind(this))
      }

      if (this.closeModalIcon) {
        this.closeModalIcon.addEventListener('click', this._closeModal.bind(this))
      }

      this._initSizeGuide()
    }

    _initSizeGuide() {
    }

    _closeModal = () => {
      document.querySelector('body').classList.remove('js-modal-open')
      document.querySelector('body').classList.remove('js-focusable-widget-open')
      this.productImagesModal.classList.remove('open')
    }

    _slideToModal = (evt) => {
        const slide = evt.currentTarget;
        const index = slide.dataset.index;
        const swiper = document.querySelector(this._selectors.productImagesModalCarousel)?.swiper;
        swiper.slideTo(index);
        document.querySelector('body').classList.add('js-modal-open')
        document.querySelector('body').classList.add('js-focusable-widget-open')
        this.productImagesModal.classList.add('open')
    }

    _slideTo = (evt) => {
        const thumbnail = evt.currentTarget;
        const index = thumbnail.dataset.index;
        const swiper = this.querySelector(this._selectors.carousel)?.swiper;

        this.querySelectorAll(this._selectors.thumbnail).forEach((button) => {
          button.classList.remove('active');
          thumbnail.setAttribute('aria-selected', 'false');
        });
    
        thumbnail.classList.add('active');
        thumbnail.setAttribute('aria-selected', 'true');
    
        swiper.slideTo(index);
      };

  
    onSubmitHandler(evt) {
      evt.preventDefault();
  
      this.handleErrorMessage();
  
      this._disableButtons();
  
      const config = {
        method: 'POST',
        headers: { Accept: `application/javascript`, 'X-Requested-With': 'XMLHttpRequest' },
      }
  
      const formData = new FormData(this.form);
    //   if (this.cart) {
    //     formData.append(
    //       'sections',
    //       this.cart.getSectionsToRender().map((section) => section.id)
    //     );
    //     formData.append('sections_url', window.location.pathname);
    //     this.cart.setActiveElement(document.activeElement);
    //   }
      config.body = formData;
  
      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          } 
          
        //   else if (!this.cart) {
        //     window.location = window.routes.cart_url;
        //     return;
        //   }
  
          if (!this.error)
            theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            // this.cart.renderContents(response);
            // this.cartDrawer.open();
          })
          .catch((e) => {
            this.handleErrorMessage(e.description)
            console.error(e);
          })
        .finally(() => {
          this._enableButtons();
        });
    }
  
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.querySelector(this._selectors.error)
  
      if (errorMessage) {
        this.errorMessageWrapper.innerHTML = errorMessage;
        this.errorMessageWrapper.classList.remove('hidden');
      }else{
        this.errorMessageWrapper.classList.add('hidden');
      }
    }
  
    _handleVariantChange = (evt) => {
      const { variant, priceChange } = evt.detail;
  
      this._updateAddToCartState(variant);
  
      if (variant) {
        if (priceChange) this._updatePrice(variant);
      }
    };
  
    _updateAddToCartState(variant) {
      const buttons = this.querySelectorAll(this._selectors.addToCart);
      if (variant) {
        if (variant.available) {
          buttons.forEach((btn) => {
            btn.textContent = "Add To Cart";
            btn.removeAttribute("disabled");
          });
        } else {
          buttons.forEach((btn) => {
            btn.textContent = "Sold out";
            btn.setAttribute("disabled", "");
          });
        }
      } else {
        buttons.forEach((btn) => {
          btn.textContent = "Unavailable";
          btn.setAttribute("disabled", "");
        });
      }
    }
  
    _updatePrice(variant) {
      //update price
    }
  
    _disableButtons() {
      this.buttons.forEach((button) => {
        button.setAttribute("disabled", "");
        const loader = button.querySelector(this._selectors.loader);
        if (loader) {
          loader.setAttribute("loading", "");
        }
      });
    }
  
    _enableButtons() {
      this.buttons.forEach((button) => {
        button.removeAttribute("disabled");
        const loader = button.querySelector(this._selectors.loader);
        if (loader) {
          loader.removeAttribute("loading");
        }
      });
    }

    _handleThumbsClick(e) {
        if (this.thumbsContainer) {
            this.thumbsContainer.classList.toggle('open');
        }
    }
  }

  customElements.define('s-product', ProductMain)